import { runLambda, LAMBDA } from './httpClient.js';
import { handleFileUploads } from './fileService.js';

export async function onSaveFunction( dataType, saveMode, record ) {
    if (saveMode === "create")  return createNewRecord( dataType, record) ;
    if (saveMode === "update" )  return updateExistingRecord( dataType, record ) ;
    console.warn(`Incorrect Save Mode: ${dataType}/${saveMode}`);
    return Promise.reject(`Missing save function`);
}



export async function fetchDashboardItems(todayDate, recordStatus) {
    const res = await runLambda( `${LAMBDA.READDASHBOARD}`,
                                 JSON.stringify({ followupDate: todayDate, recordStatus }) ) ;
    console.log("ReadDashBoard - results:", res) ;
    if (!res.ok) throw new Error('API request failed');
    return await res.json();
}



export async function fetchRecords( dataType ) {
    const res = await runLambda( `${LAMBDA.READ}`,
                                 JSON.stringify({ dataType: `${dataType}` }) ) ;
    console.log( "Read Records - result:",res ) ;
    if (!res.ok) throw new Error('Read API request failed');
    return await res.json();
}



export async function createNewRecord( dataType, payload ) {
    console.log('dataService::createNewRecord - payload:', payload );

    // Step 1: Create a record ID
    payload.recordId = crypto.randomUUID() ;

    // Step 2: Upload files if present
    await handleFileUploads(dataType, payload);
    console.log("dataService::createNewRecord - payload after handleFileUploads", payload );

    // Step 3: Create the new record - single step with the record ID now generated
    const res = await runLambda( `${LAMBDA.CREATE}`,
                                 JSON.stringify({ dataType, payload }) ) ;
    if (!res.ok) throw new Error('Create API request failed');
    return await res.json();
}



export async function updateExistingRecord( dataType, payload ) {
    console.log('dataService::updateExistingRecord - calling Lambda with:', payload );

    //Step 1 check for File Uploads first - we already have record ID, so we can do this
    await handleFileUploads(dataType, payload);

    //Step 2: Now update the record to the backend.
    const res = await runLambda( `${LAMBDA.UPDATE}`,
                                 JSON.stringify({ dataType: `${dataType}`, payload }) ) ;
    if (!res.ok) throw new Error('Update API request failed');
    return await res.json();
}



export async function deleteExistingRecord( payload ) { // dont need dataType.
    const res = await runLambda( `${LAMBDA.DELETE}`,
                                 JSON.stringify({ payload }) ) ;
    if (!res.ok) throw new Error('Delete API request failed');
    return await res.json();
}
